import { getBrowser } from '../../react/utils/Platform';

export const CAPTCHA_URL =
  'https://www.clarovideo.com/scripts/captcha/captcha.php?sid=';
export const URL_MICROFWK = 'url_dominio_microfwk';
export const DEFAULT_LOGIN_EMAIL_ASSET = 'default_login_email_asset';
export const LANDING_ESPN_EMAIL_ASSET = 'landing_espn_email_ic';
export const DEFAULT_ERROR_CODE = 'PGS_DBA_00001';
export const SSO_PLACEHOLDER_ERRORS = 'sso_placeholder_errors';
export const NOT_SUPPORT_REGION = 'Region no soportada';
export const ERROR_TRY_AGAIN = 'Lo sentimos hubo un error, intente nuevamente';
export const CLOSE = 'Cerrar';
export const LANDING_ESPN_LOGIN_LABEL = 'landing_espn_inicia_sesion_lbl';
export const LANDING_ESPN_LOGO_CLARO_TV_IC = 'landing_espn_logo_claro_tv_ic';

export const rest = {
  device_id: 'web',
  device_category: 'web',
  device_model: 'web',
  device_type: 'web',
  device_so: getBrowser(),
  format: 'json',
  device_manufacturer: 'generic',
};

export const STEPS = {
  LANDING: 0,
  EMAIL_FORM: 1,
  PASSWORD_FORM: 2,
};

export const SUBMIT_TYPES = {
  previous: 'previous',
  next: 'next',
  terms: 'terms',
  promotion: 'promotion',
  email: 'email',
  validateEmail: 'validateEmail',
  cancel: 'cancel',
  submit: 'submit',
  done: 'done',
};
